'use client';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import React, { type FC } from 'react';

import { AuthPageLayout } from '../components/AuthPageLayout';
import LoginPage from '../components/login/LoginPage';
import Page from '../components/page/Page';
import { APPLICANT_SITE_URL } from '../utils/constants';
import { convertUrlSearchParamsToObject, getUrlString } from '../utils/url';

const CANONICAL_LOGIN_LINK = `${APPLICANT_SITE_URL}/login`;

const LoginPageWrapper: FC = () => {
  const searchParams = useSearchParams();
  return (
    <Page noIndex title="Log in" canonicalLink={CANONICAL_LOGIN_LINK}>
      <div>
        <AuthPageLayout
          topRightLink={
            <div className="text-right">
              <p className="text-leland-gray-light">New to Leland?</p>
              <Link
                href={getUrlString(
                  '/signup',
                  convertUrlSearchParamsToObject(searchParams),
                )}
                className="link link--primary font-medium"
                id="login--create_account"
              >
                Create an account
              </Link>
            </div>
          }
        >
          <LoginPage />
        </AuthPageLayout>
      </div>
    </Page>
  );
};

export default LoginPageWrapper;
